/* @flow */

import { compose } from 'ramda';
import * as React from 'react';
import { useIntl } from 'react-intl';

import SignupAuthenticationWizard from './authentication/SignupAuthenticationWizard';
import SignupProfileWizard from './profile/SignupProfileWizard';
import messages from 'src/shared/app/signup/l10n/baseSignupL10n';
import DocumentTitle from 'src/shared/app/base/component/document/DocumentTitle';
import Footer from '../../onboarding/component/footer/Footer';

type Props = {
  token?: string,
};

const SignupMainDumb = ({ token }: Props): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Hooks
   |----------------------------------------------------------------------------
   */

  const intl = useIntl();

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  const wizardElt = token ? (
    <SignupProfileWizard />
  ) : (
    <SignupAuthenticationWizard />
  );

  return (
    <React.Fragment>
      <DocumentTitle>{intl.formatMessage(messages.title)}</DocumentTitle>
      {wizardElt}
      <Footer />
    </React.Fragment>
  );
};

export default compose(React.memo)(SignupMainDumb);
